module.exports = __webpack_public_path__ + "static/img/1.4272b35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/welcome/1.jpg
// module id = e7dZ
// module chunks = 0